import React from "react";
import * as Icon from "react-feather";

const horizontalMenuConfig = [
  {
    type: "groupHeader",
    groupTitle: "",
  },

  {
    id: "home",
    title: "Anasayfa",
    type: "item",
    icon: <Icon.Home size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/home",
  },
  /*{
    id: "page2",
    title: "Page 2",
    type: "item",
    icon: <Icon.File size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/page2",
  },*/
  {
    type: "groupHeader",
    groupTitle: "PET",
  },

  {
    id: "PetBilgileri",
    title: "Pet Bilgileri",
    type: "item",
    icon: <Icon.Briefcase size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/PetBilgileri",
  },
  {
    type: "groupHeader",
    groupTitle: "KLİNİK",
  },
  {
    id: "ClinicRead",
    title: "Klinik Bilgileri",
    type: "item",
    icon: <Icon.PlusSquare size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/ClinicRead",
  },

  {
    id: "VeterinerRead",
    title: "Veteriner Bilgileri",
    type: "item",
    icon: <Icon.Users size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/Veterinerler",
  },
  //test amaçlı login menüye eklendi logout
  {
    id: "Login",
    title: "Login",
    type: "item",
    icon: <Icon.Cast size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/",
  },
];

export default horizontalMenuConfig;
